import axios from "axios";
import { IAxiosReturn } from "../interface";
import { CommentableEntityType } from "../notifications/interface";
import { processAxiosError } from "../processAxiosError";

export interface handleCommentsSubscriptionDetails {
  activeContext: CommentableEntityType;
  entityId: string;
  action: "subscribe" | "unsubscribe";
}

export type ISubscriptionStatusReturn = IAxiosReturn<boolean>;

/**
 * Subscribe or unsubscribe to comment notifications for an entity.
 *
 * @param backEndUrl - Base backend URL
 * @param details - Details describing the subscription action
 * @param controller - AbortController to cancel the request
 * @returns Current subscription state wrapped in ISubscriptionStatusReturn
 */
export const handleCommentsSubscription = async (
  backEndUrl: string,
  details: handleCommentsSubscriptionDetails,
  controller: AbortController,
): Promise<ISubscriptionStatusReturn> => {
  try {
    const url = `${backEndUrl}Comments/${details.activeContext}/${details.entityId}/${details.action}`;
    const response = await axios.put(url, { signal: controller.signal });
    return { success: true, data: response.data };
  } catch (error) {
    return processAxiosError(`Failed to ${details.action}`, error);
  }
};
